
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexAei67SOKdOMeta } from "/Users/jonathan.leignier/Desktop/FC&AL FILE/Retailers/Git-Dentsu-clone v2/dentsu/pages/admin/index.vue?macro=true";
import { default as index5Cq8PnK0HbMeta } from "/Users/jonathan.leignier/Desktop/FC&AL FILE/Retailers/Git-Dentsu-clone v2/dentsu/pages/data/index.vue?macro=true";
import { default as indexroS3zCYxjsMeta } from "/Users/jonathan.leignier/Desktop/FC&AL FILE/Retailers/Git-Dentsu-clone v2/dentsu/pages/dentsu/index.vue?macro=true";
import { default as indexgQSTfUG5puMeta } from "/Users/jonathan.leignier/Desktop/FC&AL FILE/Retailers/Git-Dentsu-clone v2/dentsu/pages/distributors/[distributor]/index.vue?macro=true";
import { default as indexJhZhHjTjjrMeta } from "/Users/jonathan.leignier/Desktop/FC&AL FILE/Retailers/Git-Dentsu-clone v2/dentsu/pages/distributors/index.vue?macro=true";
import { default as indexe9jFQUqI2QMeta } from "/Users/jonathan.leignier/Desktop/FC&AL FILE/Retailers/Git-Dentsu-clone v2/dentsu/pages/index.vue?macro=true";
import { default as indexa11PfQiKcYMeta } from "/Users/jonathan.leignier/Desktop/FC&AL FILE/Retailers/Git-Dentsu-clone v2/dentsu/pages/login/index.vue?macro=true";
import { default as indexw0zUzYekhfMeta } from "/Users/jonathan.leignier/Desktop/FC&AL FILE/Retailers/Git-Dentsu-clone v2/dentsu/pages/no-access/index.vue?macro=true";
import { default as indexyBQ0XjNtLWMeta } from "/Users/jonathan.leignier/Desktop/FC&AL FILE/Retailers/Git-Dentsu-clone v2/dentsu/pages/register-lab-al/index.vue?macro=true";
import { default as indexlMpCaUFRtlMeta } from "/Users/jonathan.leignier/Desktop/FC&AL FILE/Retailers/Git-Dentsu-clone v2/dentsu/pages/register-lab-fc/index.vue?macro=true";
import { default as indexxSi6A0Bj7NMeta } from "/Users/jonathan.leignier/Desktop/FC&AL FILE/Retailers/Git-Dentsu-clone v2/dentsu/pages/retailers/[retailer]/index.vue?macro=true";
import { default as indexII3luHn6gEMeta } from "/Users/jonathan.leignier/Desktop/FC&AL FILE/Retailers/Git-Dentsu-clone v2/dentsu/pages/retailers/index.vue?macro=true";
import { default as indexgf4JwkFMfWMeta } from "/Users/jonathan.leignier/Desktop/FC&AL FILE/Retailers/Git-Dentsu-clone v2/dentsu/pages/users/index.vue?macro=true";
export default [
  {
    name: "admin",
    path: "/admin",
    meta: indexAei67SOKdOMeta || {},
    component: () => import("/Users/jonathan.leignier/Desktop/FC&AL FILE/Retailers/Git-Dentsu-clone v2/dentsu/pages/admin/index.vue")
  },
  {
    name: "data",
    path: "/data",
    meta: index5Cq8PnK0HbMeta || {},
    component: () => import("/Users/jonathan.leignier/Desktop/FC&AL FILE/Retailers/Git-Dentsu-clone v2/dentsu/pages/data/index.vue")
  },
  {
    name: "dentsu",
    path: "/dentsu",
    meta: indexroS3zCYxjsMeta || {},
    component: () => import("/Users/jonathan.leignier/Desktop/FC&AL FILE/Retailers/Git-Dentsu-clone v2/dentsu/pages/dentsu/index.vue")
  },
  {
    name: "distributors-distributor",
    path: "/distributors/:distributor()",
    meta: indexgQSTfUG5puMeta || {},
    component: () => import("/Users/jonathan.leignier/Desktop/FC&AL FILE/Retailers/Git-Dentsu-clone v2/dentsu/pages/distributors/[distributor]/index.vue")
  },
  {
    name: "distributors",
    path: "/distributors",
    meta: indexJhZhHjTjjrMeta || {},
    component: () => import("/Users/jonathan.leignier/Desktop/FC&AL FILE/Retailers/Git-Dentsu-clone v2/dentsu/pages/distributors/index.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexe9jFQUqI2QMeta || {},
    component: () => import("/Users/jonathan.leignier/Desktop/FC&AL FILE/Retailers/Git-Dentsu-clone v2/dentsu/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/Users/jonathan.leignier/Desktop/FC&AL FILE/Retailers/Git-Dentsu-clone v2/dentsu/pages/login/index.vue")
  },
  {
    name: "no-access",
    path: "/no-access",
    meta: indexw0zUzYekhfMeta || {},
    component: () => import("/Users/jonathan.leignier/Desktop/FC&AL FILE/Retailers/Git-Dentsu-clone v2/dentsu/pages/no-access/index.vue")
  },
  {
    name: "register-lab-al",
    path: "/register-lab-al",
    component: () => import("/Users/jonathan.leignier/Desktop/FC&AL FILE/Retailers/Git-Dentsu-clone v2/dentsu/pages/register-lab-al/index.vue")
  },
  {
    name: "register-lab-fc",
    path: "/register-lab-fc",
    component: () => import("/Users/jonathan.leignier/Desktop/FC&AL FILE/Retailers/Git-Dentsu-clone v2/dentsu/pages/register-lab-fc/index.vue")
  },
  {
    name: "retailers-retailer",
    path: "/retailers/:retailer()",
    meta: indexxSi6A0Bj7NMeta || {},
    component: () => import("/Users/jonathan.leignier/Desktop/FC&AL FILE/Retailers/Git-Dentsu-clone v2/dentsu/pages/retailers/[retailer]/index.vue")
  },
  {
    name: "retailers",
    path: "/retailers",
    meta: indexII3luHn6gEMeta || {},
    component: () => import("/Users/jonathan.leignier/Desktop/FC&AL FILE/Retailers/Git-Dentsu-clone v2/dentsu/pages/retailers/index.vue")
  },
  {
    name: "users",
    path: "/users",
    meta: indexgf4JwkFMfWMeta || {},
    component: () => import("/Users/jonathan.leignier/Desktop/FC&AL FILE/Retailers/Git-Dentsu-clone v2/dentsu/pages/users/index.vue")
  }
]